import lazyLoading from './lazyLoading'

export default {
  name: 'Dashboard',
  path: '/',
  component: lazyLoading('dashboard/Dashboard'),
  meta: {
    default: true,
    title: 'menu.dashboard',
    iconClass: 'vuestic-icon vuestic-icon-dashboard'
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/dashboard.js